import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate, useParams } from 'react-router-dom'

// components
import AppCard from '../../components/AppCard'
import AppForm from '../../components/form/form-policy-type/AppForm'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'
import AppModalConfirmation from '../../components/modal/AppModalConfirmation'

// helpers
import Axios from '../../helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

const EditPolicyType = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const { id } = params
  const { showSuccess, showError } = useToastMessage();

  const isLoading = useSelector((state) => state.isLoading)

  const [policyTypeDetail, setPolicyTypeDetail] = useState(null)
  const [showModalConfirm, setShowModalConfirm] = useState({ show: false })

  const formik = useFormik({
    initialValues: {
      policy_type_name: policyTypeDetail?.name || '',
      policy_type_description:  policyTypeDetail?.description || '',
    },
    validationSchema: Yup.object().shape({
      policy_type_name: Yup.string()
        .required("Please enter company policy name."),
      policy_type_description: Yup.string().required("Please enter company policy description."),
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  useEffect(() => {
    fetchDetailPolicyType()
  }, [id]);

  const fetchDetailPolicyType = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/policy-type/${id}`,
    })
      .then(({ data }) => {
        const { success, value } = data || {}
        if (success) {
          let policyTypeValue = value
          setPolicyTypeDetail(policyTypeValue)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleInputValue = (values) => {
    const body = {
      name: values.policy_type_name,
      description: values.policy_type_description
    }

    return body
  }

  const handlePost = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "post",
      url: `/api/tracker/v1/policy-type/update/${id}`,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          showSuccess('Policy type has been successfully updated')
          navigate('/policy-type/list')
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handlePost(inputPayload)
  }

  const handleSubmit = () => {
    formik.handleSubmit()

    setShowModalConfirm({ show: false })
  }

  return (
    <>
      {
        showModalConfirm.show && (
          <AppModalConfirmation 
            confirmationType="confirmation"
            showModal={showModalConfirm}
            setShowModal={setShowModalConfirm}
            headerTitle="Confirmation"
            descriptionText="Are you sure want to edit a policy type?"
            handleSubmit={handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
          />
        )
      }
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Edit Policy Type</h4>}
        bodyContent={
          <AppForm 
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
          />
        }
        footerContent={
          <ActionButtonForm
            isLoading={isLoading}
            disabled={formik.isSubmitting}
            onCancel={() => navigate('/policy-type/list')}
            onSave={() => setShowModalConfirm({ show: true })}
          />
        }
      />
    </>
  )
}

export default EditPolicyType